import { useState } from 'react';

import type { SiteTheme } from '../../../theme';

import { useAppSelector } from '../../common/hooks/useThunkDispatch';
import { featureFlagsSelectors } from '../../common/selectors/featureFlagsSelectors';

const isDarkTheme = (siteTheme: SiteTheme | undefined): boolean => {
    switch (siteTheme) {
        case 'dark':
        case 'id26-dark':
            return true;
        case 'light':
        case 'id26-light':
            return false;
        default:
            return false;
    }
};

// const darkModeMediaQuery = () => window.matchMedia('(prefers-color-scheme: dark)');

export const useIsDarkMode = () => {
    const siteTheme = useAppSelector(featureFlagsSelectors.selectSiteTheme);
    const [isSystemPreferredDarkMode] = useState(false);

    // currently only match siteTheme, we can uncomment this code when se start looking at system preferred dark mode
    // const [isSystemPreferredDarkMode, setIsSystemPreferredDarkMode] = useState(
    //     () => darkModeMediaQuery().matches,
    // );

    // useEffect(() => {
    //     const mediaQuery = darkModeMediaQuery();
    //     const handler = (e: MediaQueryListEvent) => setIsSystemPreferredDarkMode(e.matches);
    //     mediaQuery.addEventListener('change', handler);
    //     return () => mediaQuery.removeEventListener('change', handler);
    // }, []);

    if (isDarkTheme(siteTheme)) {
        return true;
    }

    return isSystemPreferredDarkMode;
};
